/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as LoginSplatRouteImport } from './routes/login.$'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected.dashboard'
import { Route as ProtectedCallsRouteImport } from './routes/_protected.calls'
import { Route as ProtectedAdminRouteImport } from './routes/_protected/admin'
import { Route as ProtectedCallsIndexRouteImport } from './routes/_protected.calls.index'
import { Route as ProtectedAdminIndexRouteImport } from './routes/_protected/admin/index'
import { Route as ProtectedCallsCallIdRouteImport } from './routes/_protected.calls.$callId'
import { Route as ProtectedAdminSchedulingRulesRouteImport } from './routes/_protected/admin/scheduling-rules'
import { Route as ProtectedAdminScheduleVisualizerRouteImport } from './routes/_protected/admin/schedule-visualizer'
import { Route as ProtectedAdminRetellAgentSyncRouteImport } from './routes/_protected/admin/retell-agent-sync'
import { Route as ProtectedAdminRestrictionConfigsRouteImport } from './routes/_protected/admin/restriction-configs'
import { Route as ProtectedAdminQaExportRouteImport } from './routes/_protected/admin/qa-export'
import { Route as ProtectedAdminProvidersRouteImport } from './routes/_protected/admin/providers'
import { Route as ProtectedAdminProviderRulesRouteImport } from './routes/_protected/admin/provider-rules'
import { Route as ProtectedAdminProviderInsuranceRouteImport } from './routes/_protected/admin/provider-insurance'
import { Route as ProtectedAdminProviderAppointmentTypesRouteImport } from './routes/_protected/admin/provider-appointment-types'
import { Route as ProtectedAdminPatientManagementRouteImport } from './routes/_protected/admin/patient-management'
import { Route as ProtectedAdminManualSyncRouteImport } from './routes/_protected/admin/manual-sync'
import { Route as ProtectedAdminInsurancePhraseMappingsRouteImport } from './routes/_protected/admin/insurance-phrase-mappings'
import { Route as ProtectedAdminFacilitiesRouteImport } from './routes/_protected/admin/facilities'
import { Route as ProtectedAdminAppointmentTypesRouteImport } from './routes/_protected/admin/appointment-types'
import { Route as ProtectedAdminAnalyticsRouteImport } from './routes/_protected/admin/analytics'
import { Route as ProtectedAdminAgentTransferDestinationsRouteImport } from './routes/_protected/admin/agent-transfer-destinations'
import { Route as ProtectedAdminAgentFacilitiesRouteImport } from './routes/_protected/admin/agent-facilities'

const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSplatRoute = LoginSplatRouteImport.update({
  id: '/login/$',
  path: '/login/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedCallsRoute = ProtectedCallsRouteImport.update({
  id: '/calls',
  path: '/calls',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedAdminRoute = ProtectedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedCallsIndexRoute = ProtectedCallsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedCallsRoute,
} as any)
const ProtectedAdminIndexRoute = ProtectedAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ProtectedAdminRoute,
} as any)
const ProtectedCallsCallIdRoute = ProtectedCallsCallIdRouteImport.update({
  id: '/$callId',
  path: '/$callId',
  getParentRoute: () => ProtectedCallsRoute,
} as any)
const ProtectedAdminSchedulingRulesRoute =
  ProtectedAdminSchedulingRulesRouteImport.update({
    id: '/scheduling-rules',
    path: '/scheduling-rules',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminScheduleVisualizerRoute =
  ProtectedAdminScheduleVisualizerRouteImport.update({
    id: '/schedule-visualizer',
    path: '/schedule-visualizer',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminRetellAgentSyncRoute =
  ProtectedAdminRetellAgentSyncRouteImport.update({
    id: '/retell-agent-sync',
    path: '/retell-agent-sync',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminRestrictionConfigsRoute =
  ProtectedAdminRestrictionConfigsRouteImport.update({
    id: '/restriction-configs',
    path: '/restriction-configs',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminQaExportRoute = ProtectedAdminQaExportRouteImport.update({
  id: '/qa-export',
  path: '/qa-export',
  getParentRoute: () => ProtectedAdminRoute,
} as any)
const ProtectedAdminProvidersRoute = ProtectedAdminProvidersRouteImport.update({
  id: '/providers',
  path: '/providers',
  getParentRoute: () => ProtectedAdminRoute,
} as any)
const ProtectedAdminProviderRulesRoute =
  ProtectedAdminProviderRulesRouteImport.update({
    id: '/provider-rules',
    path: '/provider-rules',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminProviderInsuranceRoute =
  ProtectedAdminProviderInsuranceRouteImport.update({
    id: '/provider-insurance',
    path: '/provider-insurance',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminProviderAppointmentTypesRoute =
  ProtectedAdminProviderAppointmentTypesRouteImport.update({
    id: '/provider-appointment-types',
    path: '/provider-appointment-types',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminPatientManagementRoute =
  ProtectedAdminPatientManagementRouteImport.update({
    id: '/patient-management',
    path: '/patient-management',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminManualSyncRoute =
  ProtectedAdminManualSyncRouteImport.update({
    id: '/manual-sync',
    path: '/manual-sync',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminInsurancePhraseMappingsRoute =
  ProtectedAdminInsurancePhraseMappingsRouteImport.update({
    id: '/insurance-phrase-mappings',
    path: '/insurance-phrase-mappings',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminFacilitiesRoute =
  ProtectedAdminFacilitiesRouteImport.update({
    id: '/facilities',
    path: '/facilities',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminAppointmentTypesRoute =
  ProtectedAdminAppointmentTypesRouteImport.update({
    id: '/appointment-types',
    path: '/appointment-types',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminAnalyticsRoute = ProtectedAdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => ProtectedAdminRoute,
} as any)
const ProtectedAdminAgentTransferDestinationsRoute =
  ProtectedAdminAgentTransferDestinationsRouteImport.update({
    id: '/agent-transfer-destinations',
    path: '/agent-transfer-destinations',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)
const ProtectedAdminAgentFacilitiesRoute =
  ProtectedAdminAgentFacilitiesRouteImport.update({
    id: '/agent-facilities',
    path: '/agent-facilities',
    getParentRoute: () => ProtectedAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/sign-up': typeof SignUpRoute
  '/admin': typeof ProtectedAdminRouteWithChildren
  '/calls': typeof ProtectedCallsRouteWithChildren
  '/dashboard': typeof ProtectedDashboardRoute
  '/login/$': typeof LoginSplatRoute
  '/admin/agent-facilities': typeof ProtectedAdminAgentFacilitiesRoute
  '/admin/agent-transfer-destinations': typeof ProtectedAdminAgentTransferDestinationsRoute
  '/admin/analytics': typeof ProtectedAdminAnalyticsRoute
  '/admin/appointment-types': typeof ProtectedAdminAppointmentTypesRoute
  '/admin/facilities': typeof ProtectedAdminFacilitiesRoute
  '/admin/insurance-phrase-mappings': typeof ProtectedAdminInsurancePhraseMappingsRoute
  '/admin/manual-sync': typeof ProtectedAdminManualSyncRoute
  '/admin/patient-management': typeof ProtectedAdminPatientManagementRoute
  '/admin/provider-appointment-types': typeof ProtectedAdminProviderAppointmentTypesRoute
  '/admin/provider-insurance': typeof ProtectedAdminProviderInsuranceRoute
  '/admin/provider-rules': typeof ProtectedAdminProviderRulesRoute
  '/admin/providers': typeof ProtectedAdminProvidersRoute
  '/admin/qa-export': typeof ProtectedAdminQaExportRoute
  '/admin/restriction-configs': typeof ProtectedAdminRestrictionConfigsRoute
  '/admin/retell-agent-sync': typeof ProtectedAdminRetellAgentSyncRoute
  '/admin/schedule-visualizer': typeof ProtectedAdminScheduleVisualizerRoute
  '/admin/scheduling-rules': typeof ProtectedAdminSchedulingRulesRoute
  '/calls/$callId': typeof ProtectedCallsCallIdRoute
  '/admin/': typeof ProtectedAdminIndexRoute
  '/calls/': typeof ProtectedCallsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/sign-up': typeof SignUpRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/login/$': typeof LoginSplatRoute
  '/admin/agent-facilities': typeof ProtectedAdminAgentFacilitiesRoute
  '/admin/agent-transfer-destinations': typeof ProtectedAdminAgentTransferDestinationsRoute
  '/admin/analytics': typeof ProtectedAdminAnalyticsRoute
  '/admin/appointment-types': typeof ProtectedAdminAppointmentTypesRoute
  '/admin/facilities': typeof ProtectedAdminFacilitiesRoute
  '/admin/insurance-phrase-mappings': typeof ProtectedAdminInsurancePhraseMappingsRoute
  '/admin/manual-sync': typeof ProtectedAdminManualSyncRoute
  '/admin/patient-management': typeof ProtectedAdminPatientManagementRoute
  '/admin/provider-appointment-types': typeof ProtectedAdminProviderAppointmentTypesRoute
  '/admin/provider-insurance': typeof ProtectedAdminProviderInsuranceRoute
  '/admin/provider-rules': typeof ProtectedAdminProviderRulesRoute
  '/admin/providers': typeof ProtectedAdminProvidersRoute
  '/admin/qa-export': typeof ProtectedAdminQaExportRoute
  '/admin/restriction-configs': typeof ProtectedAdminRestrictionConfigsRoute
  '/admin/retell-agent-sync': typeof ProtectedAdminRetellAgentSyncRoute
  '/admin/schedule-visualizer': typeof ProtectedAdminScheduleVisualizerRoute
  '/admin/scheduling-rules': typeof ProtectedAdminSchedulingRulesRoute
  '/calls/$callId': typeof ProtectedCallsCallIdRoute
  '/admin': typeof ProtectedAdminIndexRoute
  '/calls': typeof ProtectedCallsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/sign-up': typeof SignUpRoute
  '/_protected/admin': typeof ProtectedAdminRouteWithChildren
  '/_protected/calls': typeof ProtectedCallsRouteWithChildren
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/login/$': typeof LoginSplatRoute
  '/_protected/admin/agent-facilities': typeof ProtectedAdminAgentFacilitiesRoute
  '/_protected/admin/agent-transfer-destinations': typeof ProtectedAdminAgentTransferDestinationsRoute
  '/_protected/admin/analytics': typeof ProtectedAdminAnalyticsRoute
  '/_protected/admin/appointment-types': typeof ProtectedAdminAppointmentTypesRoute
  '/_protected/admin/facilities': typeof ProtectedAdminFacilitiesRoute
  '/_protected/admin/insurance-phrase-mappings': typeof ProtectedAdminInsurancePhraseMappingsRoute
  '/_protected/admin/manual-sync': typeof ProtectedAdminManualSyncRoute
  '/_protected/admin/patient-management': typeof ProtectedAdminPatientManagementRoute
  '/_protected/admin/provider-appointment-types': typeof ProtectedAdminProviderAppointmentTypesRoute
  '/_protected/admin/provider-insurance': typeof ProtectedAdminProviderInsuranceRoute
  '/_protected/admin/provider-rules': typeof ProtectedAdminProviderRulesRoute
  '/_protected/admin/providers': typeof ProtectedAdminProvidersRoute
  '/_protected/admin/qa-export': typeof ProtectedAdminQaExportRoute
  '/_protected/admin/restriction-configs': typeof ProtectedAdminRestrictionConfigsRoute
  '/_protected/admin/retell-agent-sync': typeof ProtectedAdminRetellAgentSyncRoute
  '/_protected/admin/schedule-visualizer': typeof ProtectedAdminScheduleVisualizerRoute
  '/_protected/admin/scheduling-rules': typeof ProtectedAdminSchedulingRulesRoute
  '/_protected/calls/$callId': typeof ProtectedCallsCallIdRoute
  '/_protected/admin/': typeof ProtectedAdminIndexRoute
  '/_protected/calls/': typeof ProtectedCallsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-up'
    | '/admin'
    | '/calls'
    | '/dashboard'
    | '/login/$'
    | '/admin/agent-facilities'
    | '/admin/agent-transfer-destinations'
    | '/admin/analytics'
    | '/admin/appointment-types'
    | '/admin/facilities'
    | '/admin/insurance-phrase-mappings'
    | '/admin/manual-sync'
    | '/admin/patient-management'
    | '/admin/provider-appointment-types'
    | '/admin/provider-insurance'
    | '/admin/provider-rules'
    | '/admin/providers'
    | '/admin/qa-export'
    | '/admin/restriction-configs'
    | '/admin/retell-agent-sync'
    | '/admin/schedule-visualizer'
    | '/admin/scheduling-rules'
    | '/calls/$callId'
    | '/admin/'
    | '/calls/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-up'
    | '/dashboard'
    | '/login/$'
    | '/admin/agent-facilities'
    | '/admin/agent-transfer-destinations'
    | '/admin/analytics'
    | '/admin/appointment-types'
    | '/admin/facilities'
    | '/admin/insurance-phrase-mappings'
    | '/admin/manual-sync'
    | '/admin/patient-management'
    | '/admin/provider-appointment-types'
    | '/admin/provider-insurance'
    | '/admin/provider-rules'
    | '/admin/providers'
    | '/admin/qa-export'
    | '/admin/restriction-configs'
    | '/admin/retell-agent-sync'
    | '/admin/schedule-visualizer'
    | '/admin/scheduling-rules'
    | '/calls/$callId'
    | '/admin'
    | '/calls'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/sign-up'
    | '/_protected/admin'
    | '/_protected/calls'
    | '/_protected/dashboard'
    | '/login/$'
    | '/_protected/admin/agent-facilities'
    | '/_protected/admin/agent-transfer-destinations'
    | '/_protected/admin/analytics'
    | '/_protected/admin/appointment-types'
    | '/_protected/admin/facilities'
    | '/_protected/admin/insurance-phrase-mappings'
    | '/_protected/admin/manual-sync'
    | '/_protected/admin/patient-management'
    | '/_protected/admin/provider-appointment-types'
    | '/_protected/admin/provider-insurance'
    | '/_protected/admin/provider-rules'
    | '/_protected/admin/providers'
    | '/_protected/admin/qa-export'
    | '/_protected/admin/restriction-configs'
    | '/_protected/admin/retell-agent-sync'
    | '/_protected/admin/schedule-visualizer'
    | '/_protected/admin/scheduling-rules'
    | '/_protected/calls/$callId'
    | '/_protected/admin/'
    | '/_protected/calls/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  SignUpRoute: typeof SignUpRoute
  LoginSplatRoute: typeof LoginSplatRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/$': {
      id: '/login/$'
      path: '/login/$'
      fullPath: '/login/$'
      preLoaderRoute: typeof LoginSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/calls': {
      id: '/_protected/calls'
      path: '/calls'
      fullPath: '/calls'
      preLoaderRoute: typeof ProtectedCallsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/admin': {
      id: '/_protected/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof ProtectedAdminRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/calls/': {
      id: '/_protected/calls/'
      path: '/'
      fullPath: '/calls/'
      preLoaderRoute: typeof ProtectedCallsIndexRouteImport
      parentRoute: typeof ProtectedCallsRoute
    }
    '/_protected/admin/': {
      id: '/_protected/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof ProtectedAdminIndexRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/calls/$callId': {
      id: '/_protected/calls/$callId'
      path: '/$callId'
      fullPath: '/calls/$callId'
      preLoaderRoute: typeof ProtectedCallsCallIdRouteImport
      parentRoute: typeof ProtectedCallsRoute
    }
    '/_protected/admin/scheduling-rules': {
      id: '/_protected/admin/scheduling-rules'
      path: '/scheduling-rules'
      fullPath: '/admin/scheduling-rules'
      preLoaderRoute: typeof ProtectedAdminSchedulingRulesRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/schedule-visualizer': {
      id: '/_protected/admin/schedule-visualizer'
      path: '/schedule-visualizer'
      fullPath: '/admin/schedule-visualizer'
      preLoaderRoute: typeof ProtectedAdminScheduleVisualizerRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/retell-agent-sync': {
      id: '/_protected/admin/retell-agent-sync'
      path: '/retell-agent-sync'
      fullPath: '/admin/retell-agent-sync'
      preLoaderRoute: typeof ProtectedAdminRetellAgentSyncRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/restriction-configs': {
      id: '/_protected/admin/restriction-configs'
      path: '/restriction-configs'
      fullPath: '/admin/restriction-configs'
      preLoaderRoute: typeof ProtectedAdminRestrictionConfigsRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/qa-export': {
      id: '/_protected/admin/qa-export'
      path: '/qa-export'
      fullPath: '/admin/qa-export'
      preLoaderRoute: typeof ProtectedAdminQaExportRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/providers': {
      id: '/_protected/admin/providers'
      path: '/providers'
      fullPath: '/admin/providers'
      preLoaderRoute: typeof ProtectedAdminProvidersRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/provider-rules': {
      id: '/_protected/admin/provider-rules'
      path: '/provider-rules'
      fullPath: '/admin/provider-rules'
      preLoaderRoute: typeof ProtectedAdminProviderRulesRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/provider-insurance': {
      id: '/_protected/admin/provider-insurance'
      path: '/provider-insurance'
      fullPath: '/admin/provider-insurance'
      preLoaderRoute: typeof ProtectedAdminProviderInsuranceRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/provider-appointment-types': {
      id: '/_protected/admin/provider-appointment-types'
      path: '/provider-appointment-types'
      fullPath: '/admin/provider-appointment-types'
      preLoaderRoute: typeof ProtectedAdminProviderAppointmentTypesRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/patient-management': {
      id: '/_protected/admin/patient-management'
      path: '/patient-management'
      fullPath: '/admin/patient-management'
      preLoaderRoute: typeof ProtectedAdminPatientManagementRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/manual-sync': {
      id: '/_protected/admin/manual-sync'
      path: '/manual-sync'
      fullPath: '/admin/manual-sync'
      preLoaderRoute: typeof ProtectedAdminManualSyncRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/insurance-phrase-mappings': {
      id: '/_protected/admin/insurance-phrase-mappings'
      path: '/insurance-phrase-mappings'
      fullPath: '/admin/insurance-phrase-mappings'
      preLoaderRoute: typeof ProtectedAdminInsurancePhraseMappingsRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/facilities': {
      id: '/_protected/admin/facilities'
      path: '/facilities'
      fullPath: '/admin/facilities'
      preLoaderRoute: typeof ProtectedAdminFacilitiesRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/appointment-types': {
      id: '/_protected/admin/appointment-types'
      path: '/appointment-types'
      fullPath: '/admin/appointment-types'
      preLoaderRoute: typeof ProtectedAdminAppointmentTypesRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/analytics': {
      id: '/_protected/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof ProtectedAdminAnalyticsRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/agent-transfer-destinations': {
      id: '/_protected/admin/agent-transfer-destinations'
      path: '/agent-transfer-destinations'
      fullPath: '/admin/agent-transfer-destinations'
      preLoaderRoute: typeof ProtectedAdminAgentTransferDestinationsRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
    '/_protected/admin/agent-facilities': {
      id: '/_protected/admin/agent-facilities'
      path: '/agent-facilities'
      fullPath: '/admin/agent-facilities'
      preLoaderRoute: typeof ProtectedAdminAgentFacilitiesRouteImport
      parentRoute: typeof ProtectedAdminRoute
    }
  }
}

interface ProtectedAdminRouteChildren {
  ProtectedAdminAgentFacilitiesRoute: typeof ProtectedAdminAgentFacilitiesRoute
  ProtectedAdminAgentTransferDestinationsRoute: typeof ProtectedAdminAgentTransferDestinationsRoute
  ProtectedAdminAnalyticsRoute: typeof ProtectedAdminAnalyticsRoute
  ProtectedAdminAppointmentTypesRoute: typeof ProtectedAdminAppointmentTypesRoute
  ProtectedAdminFacilitiesRoute: typeof ProtectedAdminFacilitiesRoute
  ProtectedAdminInsurancePhraseMappingsRoute: typeof ProtectedAdminInsurancePhraseMappingsRoute
  ProtectedAdminManualSyncRoute: typeof ProtectedAdminManualSyncRoute
  ProtectedAdminPatientManagementRoute: typeof ProtectedAdminPatientManagementRoute
  ProtectedAdminProviderAppointmentTypesRoute: typeof ProtectedAdminProviderAppointmentTypesRoute
  ProtectedAdminProviderInsuranceRoute: typeof ProtectedAdminProviderInsuranceRoute
  ProtectedAdminProviderRulesRoute: typeof ProtectedAdminProviderRulesRoute
  ProtectedAdminProvidersRoute: typeof ProtectedAdminProvidersRoute
  ProtectedAdminQaExportRoute: typeof ProtectedAdminQaExportRoute
  ProtectedAdminRestrictionConfigsRoute: typeof ProtectedAdminRestrictionConfigsRoute
  ProtectedAdminRetellAgentSyncRoute: typeof ProtectedAdminRetellAgentSyncRoute
  ProtectedAdminScheduleVisualizerRoute: typeof ProtectedAdminScheduleVisualizerRoute
  ProtectedAdminSchedulingRulesRoute: typeof ProtectedAdminSchedulingRulesRoute
  ProtectedAdminIndexRoute: typeof ProtectedAdminIndexRoute
}

const ProtectedAdminRouteChildren: ProtectedAdminRouteChildren = {
  ProtectedAdminAgentFacilitiesRoute: ProtectedAdminAgentFacilitiesRoute,
  ProtectedAdminAgentTransferDestinationsRoute:
    ProtectedAdminAgentTransferDestinationsRoute,
  ProtectedAdminAnalyticsRoute: ProtectedAdminAnalyticsRoute,
  ProtectedAdminAppointmentTypesRoute: ProtectedAdminAppointmentTypesRoute,
  ProtectedAdminFacilitiesRoute: ProtectedAdminFacilitiesRoute,
  ProtectedAdminInsurancePhraseMappingsRoute:
    ProtectedAdminInsurancePhraseMappingsRoute,
  ProtectedAdminManualSyncRoute: ProtectedAdminManualSyncRoute,
  ProtectedAdminPatientManagementRoute: ProtectedAdminPatientManagementRoute,
  ProtectedAdminProviderAppointmentTypesRoute:
    ProtectedAdminProviderAppointmentTypesRoute,
  ProtectedAdminProviderInsuranceRoute: ProtectedAdminProviderInsuranceRoute,
  ProtectedAdminProviderRulesRoute: ProtectedAdminProviderRulesRoute,
  ProtectedAdminProvidersRoute: ProtectedAdminProvidersRoute,
  ProtectedAdminQaExportRoute: ProtectedAdminQaExportRoute,
  ProtectedAdminRestrictionConfigsRoute: ProtectedAdminRestrictionConfigsRoute,
  ProtectedAdminRetellAgentSyncRoute: ProtectedAdminRetellAgentSyncRoute,
  ProtectedAdminScheduleVisualizerRoute: ProtectedAdminScheduleVisualizerRoute,
  ProtectedAdminSchedulingRulesRoute: ProtectedAdminSchedulingRulesRoute,
  ProtectedAdminIndexRoute: ProtectedAdminIndexRoute,
}

const ProtectedAdminRouteWithChildren = ProtectedAdminRoute._addFileChildren(
  ProtectedAdminRouteChildren,
)

interface ProtectedCallsRouteChildren {
  ProtectedCallsCallIdRoute: typeof ProtectedCallsCallIdRoute
  ProtectedCallsIndexRoute: typeof ProtectedCallsIndexRoute
}

const ProtectedCallsRouteChildren: ProtectedCallsRouteChildren = {
  ProtectedCallsCallIdRoute: ProtectedCallsCallIdRoute,
  ProtectedCallsIndexRoute: ProtectedCallsIndexRoute,
}

const ProtectedCallsRouteWithChildren = ProtectedCallsRoute._addFileChildren(
  ProtectedCallsRouteChildren,
)

interface ProtectedRouteChildren {
  ProtectedAdminRoute: typeof ProtectedAdminRouteWithChildren
  ProtectedCallsRoute: typeof ProtectedCallsRouteWithChildren
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedAdminRoute: ProtectedAdminRouteWithChildren,
  ProtectedCallsRoute: ProtectedCallsRouteWithChildren,
  ProtectedDashboardRoute: ProtectedDashboardRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  SignUpRoute: SignUpRoute,
  LoginSplatRoute: LoginSplatRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
